export function camelCaseToWords(text: string): string {
  return text
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // Insert space before uppercase letters
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // Insert space between two uppercase letters if the second is followed by a lowercase letter
    .replace(/([a-z])([0-9])/g, '$1 $2') // Insert space before numbers
    .replace(/([0-9])([a-zA-Z])/g, '$1 $2') // Insert space after numbers
    .replace(/([a-zA-Z0-9])([A-Z0-9])/g, '$1 $2') // Insert space between a lowercase/number and an uppercase/number
    .replace(/\s+/g, ' ') // Remove extra spaces
    .trim(); // Trim spaces at the beginning and end
}
